<template>
  <div class="locationIndex">
    <div class="flex_row flex_align_center" style="margin-bottom: 20px;">
      <el-input v-model.trim="tableObj.deviceName" :placeholder="$t('AllDevices.SearchDeviceNameOrSn')" clearable
        @clear="changeSearch" @change="changeSearch" style="width: 300px; margin-right: 10px;">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
      <search-company v-model="tableObj.selectCompany" @change="changeSearch" style="margin-right: 10px;"></search-company>
      <el-select v-model="tableObj.status" :placeholder="$t('button.select')" @change="changeSearch">
        <el-option :label="$t('sim.all')" :value="-1"> </el-option>
        <el-option :label="$t('location.geofencing') +' '+ $t('location.disable')" :value="0"> </el-option>
        <el-option :label="$t('location.geofencing') +' '+ $t('location.enable')" :value="1"> </el-option>
      </el-select>
    </div>
    <el-table v-loading="loading" :data="tableData" border @filter-change="filterTagTable"
      @sort-change="sortChange">

      <el-table-column :label="$t('dashboard.DeviceName')" prop="deviceName"></el-table-column>
      <el-table-column :label="$t('BondOrUpdateDevice.OwnedCompany')" prop="OwnedCompany">
        <template slot-scope="scope">
          {{ handleCompanyName(scope.row.companyId)}}
        </template>
      </el-table-column>
      <el-table-column :filter-multiple="false" :filters="filterDate" :label="sortDate" column-key="dateTime"
        prop="dateTime" sortable="custom" />
      <el-table-column :label="$t('location.geofencing')" prop="electricFence">

        <template slot-scope="scope">

          <el-link style="margin-right: 10px;" type="primary"
            @click="goToElectricFence(scope.row)">{{$t('AllDevices.View')}}</el-link>

          <el-switch v-if="scope.row.locationStatus2 == 1 || $store.state.isAdmin"
            v-model="scope.row.electricFenceOn" 
            @change="openElectricFence(scope.$index,scope.row)" />

          <el-link v-if="scope.row.historicalRunOn" style="margin-right: 10px;" type="primary"
            @click="goToTraceMap(scope.row)">{{ $t('location.trackReplay') }}</el-link>

        </template>
      </el-table-column>
    </el-table>
    <!-- 列表模块————分页 -->
    <el-pagination v-if="pageshow" :page-size="listQuery.pageInfo.limit" :page-sizes="listQuery.pageInfo.pageList"
      :total="listQuery.pageInfo.total" background current-page.sync="listQuery.pageInfo.page"
      layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange"
      @size-change="handleSizeChange" style="margin-top: 20px;" />
  </div>
</template>

<script>
import { findGeofenceDeviceList, updateGnssConfig, updateGnssGeofenceStatus } from '@/api/locationManagement'
import { pagination } from '@/utils/init_table' // 分页
import { getDateAndHour } from '@/utils/updateTime.js'
import PieChartCici from '@/components/pieChart'
import lineChartTwo from '@/components/lineChartTwo'
import SelectComp from '@/components/SelectComp.vue'
import SearchCompany from '@/components/SearchCompany.vue'
import { mapState } from 'vuex'

export default {
  name: 'DashboardAdmin',
  components: {
    PieChartCici,
    lineChartTwo,
    SelectComp,
    SearchCompany
  },
  data () {
    return {
      // flag: false,//判断电子围栏是否可点击
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      pieSeriesData: [],
      lineDate: [],
      lineHeight: '300px',
      machineNum: 0,
      pieHeight: '250px',
      tableData: [],
      companyOptions: [], // 下拉框--公司
      haveChildCompany: false, // 是否有子公司
      allChildCompanyArr: [], // 所有子公司
      allCompanyArr: [], // 所有公司
      column: { prop: 'dateTime', order: 'ascending' }, // el-table-column中的prop  'ascending' or 'descending',
      tableObj: {
        deviceName: '', // 删选--设备名称/sn/mcuId
        selectDate: '', // 删选--时间：bondTime/updateTime
        order: '', // 删选--排序方式：'ascending' or 'descending'
        selectCompany: [], // 删选--公司
        status: -1 // 删选--电子围栏开关
      },
      // /////////////////
      companyId: '', // 选中的公司
      selectDay: [], // 起始日期,
      inputDevName: null, // 输入设备名称、sn
      nameTableData: [],
      selectedImgIndex: -1, // 选项卡选中的index
      oldselectedImgIndex: -1, // 选项卡上次选中的index
      selectDevice: null,
      bindDeviceDialogTitle: '新增设备',
      companylistQuery: {
        pageInfo: {
          pageNum: 1,
          pageSize: 10000,
          pageNo: 1,
          total: 0,
          pageList: [10, 20, 30, 50]
        }
      },
      sort: 'bondTime',
      sortDate: '',
      loading: true
    }
  },
  computed: {
    ...mapState(['companyOption']),
    language () {
      return this.$store.state.language
    },
    filterDate () {
      return [
        { text: this.$t('basicinfo.BindingTime'), value: 'bondTime' },
        { text: this.$t('dashboard.LatestUpdate'), value: 'updateTime' }
      ]
    },
    electricFenceOptions () {
      return [
        { text: this.$t('location.enable'), value: '1' },
        { text: this.$t('location.disable'), value: '0' }
      ]
    }
  },
  watch: {
    language (newValue, oldValue) {
      if (this.sort == 'bondTime') {
        this.sortDate = this.$t('basicinfo.BindingTime')
      } else {
        this.sortDate = this.$t('dashboard.LatestUpdate')
      }
    }
  },
  mounted () {
    console.log(this.$i18n.messages['zh'])
    this.sortDate = this.$t('basicinfo.BindingTime')
    this.queryList()
    if (this.$store.state.map == 'gdMap') {
      this.value1 = true
    } else {
      this.value1 = false
    }
  },
  methods: {
    handleCompanyName (val) {
      const obj = this.companyOption.find(item => item.companyId == val)
      if (obj) return obj.companyName
      return val
    },
    fullScreen (height) {
      this.height = height
    },
    queryList () {
      var param = {
        companyIdList: this.tableObj.selectCompany,
        key: this.tableObj.deviceName,
        orderBy: '',
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize, // 分页--每一页的列表的行数 10 20 50
        status: this.tableObj.status
      }
      if (this.tableObj.selectDate == 'updateTime') {
        switch (this.tableObj.order) {
          case 'descending': param.orderBy = 3; break
          case 'ascending': param.orderBy = 4; break
          default: param.orderBy = 3; break
        }
      } else {
        switch (this.tableObj.order) {
          case 'descending': param.orderBy = 1; break
          case 'ascending': param.orderBy = 2; break
          default: param.orderBy = 1; break
        }
      }
      this.loading = true
      findGeofenceDeviceList(param).then(response => {
        console.log('设备列表', response)
        this.loading = false
        this.tableData = response.resultModel.list // 设备数据
        this.listQuery.pageInfo.total = response.resultModel.total // 分页
        this.locationList = []
        this.tableData.forEach(v => {
          if (this.tableObj.selectDate == 'updateTime') {
            // 最后更新时间
            if (v.lastOnlineTime) v.dateTime = getDateAndHour(v.lastOnlineTime)
          } else {
            // 绑定时间
            if (v.createTime) v.dateTime = getDateAndHour(v.createTime)
          }
          // if (this.companyOptions.length >= 1) {
          //   // 有子公司
          //   this.companyOptions.forEach(m => {
          //     if (v.companyId == m.value) v.OwnedCompany = m.text
          //   })
          // }
          v.electricFenceOn = v.geofenceStatus == 1
          // locationStatus:是否开启轨迹 0没有，2开启
          // extralArr2[1] === 1 ? 2 : 1// 运动轨迹
          var extralArr2 = this.decimalToBinary(v.extralFuntion, 2)
          if (extralArr2[1] == 1) {
            // 是否有开轨迹回放
            v.historicalRunOn = true
          } else {
            v.historicalRunOn = false
          }
        })
      })
    },
    sortChange (column) {
      // order: descending/ascending/null
      this.tableObj.order = column.order
      this.queryList()
    },
    
    filterHandler (value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    filterTagTable (filter) {
      if (filter.dateTime) {
        this.tableObj.selectDate = filter.dateTime.length == 0 ? [] : filter.dateTime[0]
        if (filter.dateTime.length == 0 || (filter.dateTime.length > 0 && filter.dateTime[0] == 'bondTime')) {
          this.sortDate = this.$t('basicinfo.BindingTime')
          this.sort = 'bondTime'
        } else {
          this.sort = 'updateTime'
          this.sortDate = this.$t('dashboard.LatestUpdate')
        }
      }
      if (filter.OwnedCompany) {
        this.tableObj.selectCompany = filter.OwnedCompany
      }
      
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    // 筛选改变事件
    changeSearch () {

      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    decimalToBinary (num, digits) { // 十进制转二进制  digits:代表传过来的是几位数，避免用<10判断出错，如：01 本应该转成8位，却转成了4位
      var myNum = num
      var b = []
      while (1) {
        var remainder = num % 2
        b.unshift(remainder)
        num = parseInt(num / 2)
        if (num == 0) break
      }
      var len
      if (!digits || digits == 1) {
        len = 4 - b.length
        for (var i = 0; i < len; i++) {
          b.unshift(0)
        }
        // } else if (myNum >= 10 && myNum < 100) {
      } else if (digits == 2) {
        len = 8 - b.length
        for (var j = 0; j < len; j++) {
          b.unshift(0)
        }
      }
      return b.reverse()
    },
    handleSizeChange (val, e) {
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange (val, e) {
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    },
    openElectricFence (index, row) {
      // 是否开启电子围栏
      if (!row.electricFenceOn) {
        // 关闭电子围栏
        this.$confirm(this.$t('location.disableGeofencing'), '', {
          // 是否关闭电子围栏
          confirmButtonText: this.$t('button.Confirm'),
          cancelButtonText: this.$t('button.Cancel'),
          type: 'warning'
        }).then(() => {
          updateGnssGeofenceStatus({ mcuId: row.mcuId, status: 0 }).then(res => {
            if (res.resultCode == '1001') {
              this.updateGnssConfig(row.mcuId, 0)
              this.tableData[index].electricFenceOn = false
              console.log(this.tableData)
              this.queryList()
              this.$message({
                type: 'success',
                message: this.$t('location.disabled') // '成功关闭电子围栏!'
              })
            }
          })
        }).catch(() => {
          this.tableData[index].electricFenceOn = true
          // this.$message({
          //   type: 'info',
          //   message: '已取消开启电子围栏'
          // })
        })
      } else {
        this.$confirm(this.$t('location.enableGeofencing'), '', {
          // '是否开启电子围栏?'
          confirmButtonText: this.$t('button.Confirm'), // '确定',
          cancelButtonText: this.$t('button.Cancel'), // '取消',
          type: 'warning'
        }).then(() => {
          updateGnssGeofenceStatus({ mcuId: row.mcuId, status: 1 }).then(res => {
            if (res.resultCode == '1001') {
              this.updateGnssConfig(row.mcuId, 1)
              this.queryList()
              this.$message({
                type: 'success',
                message: this.$t('location.enabled') // '成功开启电子围栏!'
              })
            }
          })
        }).catch(() => {
          this.tableData[index].electricFenceOn = false
        })
      }
    },
    goToElectricFence (row) {
      const routeData = {
        path: '/locationMagt/electricFence',
        query: {
          mcuId: row.mcuId,
          sn: row.deviceSn,
          deviceName: row.deviceName,
          geofenceStatus: row.geofenceStatus
        }
      }
      if (row.locationStatus2 == 0 && !this.$store.state.isAdmin) {
        this.$message({
          type: 'warning',
          message: this.$t('location.GPSWaring')
        })
      } else {
        this.$router.push(routeData)
      }
    },
    goToTraceMap (row) {
      var endtime = Date.parse(new Date())
      const routeData = {
        path: '/locationMagt/traceMap',
        query: {
          mcuId: row.mcuId,
          deviceName: row.deviceName,
          startTime: endtime - 1000 * 60 * 60 * 24,
          endTime: endtime
        }
      }
      if (row.locationStatus2 == 0 && !this.$store.state.isAdmin) {
        this.$message({
          type: 'warning',
          message: this.$t('location.GPSWaring1')
        })
      } else {
        this.$router.push(routeData)
      }
    },
    updateGnssConfig (mcuId, isOnlyGPS) {
      if (isOnlyGPS !== 'undefined') {
        updateGnssConfig({ mcuId: mcuId, gpsOnly: isOnlyGPS }).then(
          response => {
            // this.getRealTimeInfo2()
          }
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.locationIndex {
  height: 100%;
  background-color: #fff;
  padding: 20px;
  #headChartWarp {
    height: 300px;
    margin: 0 -20px;
    .el-col {
      height: 100%;
      // background: #fff;
      padding: 0 20px;
    }
    .el-col > div {
      background: #fff;
      height: 100%;
    }
    .el-col:nth-of-type(3) > div {
      padding: 10px;
    }
  }
  #tableWarp {
    // height:500px;
    margin: 0 -20px;
    .el-col {
      height: 100%;
      padding: 0 20px;
    }
    .el-col > div {
      background: #fff;
      height: 100%;
    }
    .el-col:nth-of-type(3) > div {
      padding: 10px;
    }
  }
}
.headContent {
  position: absolute;
  // z-index: 999;
  margin: 0 60px -60px 16px;
  float: left;
  top: 20px;
  width: 100%;
}
.headContent img {
  width: 80px;
}
.headContentQuestion {
  font-size: 22px;
  color: #a5a5a5;
  display: inline-block;
  vertical-align: top;
  margin: 7px 0 0 -5px;
  cursor: pointer;
}
.questionPop {
  display: inline-block;
  background: white;
  padding: 14px;
  vertical-align: top;
  box-shadow: 1px 1px 5px #ccc;
  position: absolute;
  z-index: 999;
  margin: -8px 0 0 -240px;
  width: 30%;
}
.allDevice {
  width: 80px;
  height: 54px;
  line-height: 54px;
  vertical-align: top;
  background: white;
  font-size: 36px;
  color: #1990fc;
  text-align: center;
  border: 1px solid #e6e9edc9;
  border-radius: 3px;
  margin-right: -5px;
}
.allDeviceActive {
  border: 2px solid #3ea5f7;
}
.formRow {
  display: inline-block;
}
.redWarningRadiu {
  font-size: 20px;
  // margin-top: 5px;
  width: 10px;
  height: 10px;
  display: inline-block;
  position: absolute;
  z-index: 200;
  background: red;
  border-radius: 50%;
  left: calc(50% + 15px);
  top: 0px;
}
</style>
